import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { api } from "@/lib/api";
import { CATEGORIES } from "@/lib/data";
import { ArrowLeft } from "lucide-react";

export default function AdminQuestions() {
  const nav = useNavigate();
  const [items, setItems] = useState([]);
  const [edited, setEdited] = useState({});

  const load = async () => {
    const { data } = await api.get("/admin/questions");
    setItems(data.questions || []);
  };

  useEffect(() => {
    if (!localStorage.getItem("life101_admin_token")) { nav("/admin/login"); return; }
    load();
  }, [nav]);

  const change = (id, field, value) => {
    setEdited((e) => ({ ...e, [id]: { ...(e[id] || items.find(i => i.id === id)), [field]: value } }));
  };

  const save = async (id) => {
    const orig = items.find((i) => i.id === id);
    const draft = edited[id];
    if (!draft) return;
    const payload = {
      id: orig.id,
      category: draft.category ?? orig.category,
      measure: draft.measure ?? orig.measure,
      text: draft.text ?? orig.text,
    };
    try {
      await api.put(`/admin/questions/${id}`, payload);
      toast.success(`Soru ${id} güncellendi`);
      setEdited((e) => { const c = { ...e }; delete c[id]; return c; });
      load();
    } catch {
      toast.error("Güncellenemedi");
    }
  };

  return (
    <div className="min-h-screen text-white" style={{ background: "#050505" }} data-testid="admin-questions-page">
      <header className="max-w-7xl mx-auto px-6 py-7 flex items-center justify-between">
        <Link to="/admin" className="text-sm text-neutral-400 hover:text-white inline-flex items-center gap-2"><ArrowLeft size={16} /> Dashboard</Link>
        <h1 className="text-xl font-semibold">Test Soruları</h1>
      </header>
      <main className="max-w-7xl mx-auto px-6 pb-16">
        <p className="text-sm text-neutral-500 mb-6">50 soruyu buradan düzenleyebilirsin. Değişiklikler kullanıcılara anında yansır.</p>
        <div className="space-y-3">
          {items.map((q) => {
            const draft = edited[q.id] || q;
            const dirty = !!edited[q.id];
            return (
              <div key={q.id} className="glass-solid p-5" data-testid={`question-${q.id}`}>
                <div className="flex flex-wrap items-start gap-4">
                  <div className="text-xs uppercase tracking-[0.15em] text-neutral-500 w-12 pt-2">#{q.id}</div>
                  <select value={draft.category} onChange={(e) => change(q.id, "category", e.target.value)} className="bg-transparent border border-white/10 rounded-lg text-white py-2 px-3 text-sm">
                    {CATEGORIES.map((c) => <option key={c.key} value={c.key} className="bg-black">{c.label}</option>)}
                  </select>
                  <input value={draft.measure} onChange={(e) => change(q.id, "measure", e.target.value)} placeholder="Ölçü" className="flex-1 min-w-[160px] bg-transparent border border-white/10 rounded-lg text-white py-2 px-3 text-sm" />
                  {dirty && (
                    <button onClick={() => save(q.id)} className="btn-primary text-xs" data-testid={`save-q-${q.id}`}>Kaydet</button>
                  )}
                </div>
                <textarea value={draft.text} onChange={(e) => change(q.id, "text", e.target.value)} rows={2} className="mt-3 w-full bg-transparent border border-white/10 rounded-lg text-white py-2 px-3 text-sm resize-none" />
              </div>
            );
          })}
        </div>
      </main>
    </div>
  );
}
